type Props = {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: Props) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : "items-start"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
          <span className="w-5 h-px bg-accent-500" />
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
        {title}
      </h2>
      {description && (
        <p className={`max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>
          {description}
        </p>
      )}
    </div>
  );
}